(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    /* +/- buttons update the matching input, then submit the cart form so
       Shopify recalculates totals via the standard /cart POST. */
    form.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-qty-step]');
      if (!btn) return;
      var control = btn.parentElement;
      var input = control && control.querySelector('[data-qty-input]');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
      var current = parseInt(input.value, 10) || 0;
      var next = current + step;
      if (next < 0) next = 0;
      input.value = String(next);
      form.submit();
    });

    /* Manual edits to the qty input submit on blur or Enter. */
    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-qty-input]')) {
        form.submit();
      }
    });
    form.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.matches('[data-qty-input]')) {
        event.preventDefault();
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var dialog = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-menu-open]');
    var closeBtn = document.querySelector('[data-menu-close]');

    function openMenu() {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    function closeMenu() {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (dialog) {
      dialog.addEventListener('close', function () {
        document.documentElement.style.overflow = '';
      });
    }

    // Mobile: tap a parent-with-children link to expand/collapse instead of navigate
    var submenuToggles = document.querySelectorAll('[data-mobile-submenu-toggle]');
    Array.prototype.forEach.call(submenuToggles, function (link) {
      link.addEventListener('click', function (event) {
        if (window.innerWidth >= 750) return;
        event.preventDefault();
        var item = link.parentElement;
        var isOpen = item.classList.toggle('is-expanded');
        link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    /* Gallery image switching */
    var images = section.querySelectorAll('[data-image-index]');

    function activateImage(index) {
      var idx = String(index);
      images.forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.imageIndex === idx);
      });
    }

    /* Variant selection */
    var variantsScript = section.parentElement.querySelector('[data-product-variants]')
      || document.querySelector('[data-product-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
    }

    var variantInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var stickyPriceEl = document.querySelector('[data-sticky-price]');
    var buttonText = section.querySelector('[data-button-text]');
    var stickyButtonText = document.querySelector('[data-sticky-button-text]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');

    function getSelectedOptions() {
      var selected = [];
      section.querySelectorAll('[data-option-value]:checked').forEach(function (input) {
        selected[parseInt(input.dataset.optionIndex, 10)] = input.dataset.optionValue;
      });
      return selected;
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.length === options.length
          && v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    /* Selected-variant details next to the price (e.g. "$695 | Large Frame").
       Reads the checked radio's `.product-page__option-value-primary` text
       — same visible label the picker shows — so we don't duplicate the
       size mapping logic here. Detection of which fieldset is "size" vs
       "format" is fuzzy on the legend text to match different option names:
         SIZE   ← legend contains "size"
         FORMAT ← legend contains frame / framing / format / print / style */
    var variantDetailsEl = section.querySelector('[data-variant-details]');
    function computeSelectedVariantDetails() {
      var sizeText = '';
      var fmtText = '';
      var fieldsets = section.querySelectorAll('fieldset.product-page__option-group');
      Array.prototype.forEach.call(fieldsets, function (fs) {
        var legend = fs.querySelector('legend');
        if (!legend) return;
        var name = (legend.textContent || '').toLowerCase();
        if (name.indexOf('quantity') !== -1) return;
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        var label = fs.querySelector('label[for="' + checked.id + '"]');
        var primary = label && label.querySelector('.product-page__option-value-primary');
        var text = primary ? primary.textContent.trim() : (checked.value || '').trim();
        if (name.indexOf('size') !== -1) {
          sizeText = text;
        } else if (
          name.indexOf('frame') !== -1 ||
          name.indexOf('framing') !== -1 ||
          name.indexOf('format') !== -1 ||
          name.indexOf('print') !== -1 ||
          name.indexOf('style') !== -1
        ) {
          /* Simplify the format label the same way the Liquid render does:
             "Print Only" → "Print"; any "* Frame" → "Frame". */
          var lower = text.toLowerCase();
          if (lower.indexOf('print') !== -1) {
            fmtText = 'Print';
          } else if (lower.indexOf('frame') !== -1) {
            fmtText = 'Frame';
          } else {
            fmtText = text;
          }
        }
      });
      if (sizeText && fmtText) return sizeText + ' ' + fmtText;
      if (sizeText) return sizeText;
      if (fmtText) return fmtText;
      return '';
    }
    function updateVariantDetails() {
      if (!variantDetailsEl) return;
      var details = computeSelectedVariantDetails();
      variantDetailsEl.innerHTML = details ? ' | ' + details : '';
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price;
      if (stickyPriceEl) stickyPriceEl.innerHTML = variant.price;
      updateVariantDetails();
      if (buttonText) buttonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stickyButtonText) stickyButtonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (addToCartBtn) {
        if (variant.available) addToCartBtn.removeAttribute('disabled');
        else addToCartBtn.setAttribute('disabled', '');
      }
      if (variant.featured_image_index !== null
        && variant.featured_image_index !== undefined
        && variant.featured_image_index >= 0) {
        activateImage(variant.featured_image_index);
      }
    }

    function updateAvailability() {
      var selectedOptions = getSelectedOptions();
      section.querySelectorAll('[data-option-value]').forEach(function (input) {
        var optionIndex = parseInt(input.dataset.optionIndex, 10);
        var optionValue = input.dataset.optionValue;
        var testOptions = selectedOptions.slice();
        testOptions[optionIndex] = optionValue;
        var hasAvailable = variants.some(function (v) {
          return v.available && v.options.every(function (opt, i) { return opt === testOptions[i]; });
        });
        input.disabled = !hasAvailable;
      });
    }

    section.querySelectorAll('[data-option-value]').forEach(function (input) {
      input.addEventListener('change', function () {
        var matched = findVariant(getSelectedOptions());
        updateForVariant(matched);
        updateAvailability();
      });
    });

    updateAvailability();

    /* Sticky mobile cart reveal */
    var stickyCart = document.querySelector('[data-sticky-cart]');
    var productInfo = section.querySelector('[data-product-info]');
    if (stickyCart && productInfo && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          var below = entries[0].boundingClientRect.top < 0 && !entries[0].isIntersecting;
          stickyCart.classList.toggle('is-visible', below);
          stickyCart.setAttribute('aria-hidden', below ? 'false' : 'true');
        },
        { rootMargin: '0px 0px -200px 0px', threshold: 0 }
      );
      stickyObserver.observe(productInfo);
    }

    /* Sticky cart button submits the main form */
    var stickyAddToCart = document.querySelector('[data-sticky-add-to-cart]');
    var productForm = section.querySelector('form.product-page__form');
    if (stickyAddToCart && productForm) {
      stickyAddToCart.addEventListener('click', function () {
        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit();
        } else {
          productForm.submit();
        }
      });
    }

    /* Step 3: AJAX add to cart → open bar on success.
       No bar population or header count update yet — those come in later steps.
       Falls back to a standard form submit if the AJAX call fails. */
    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        if (productForm.dataset.skipAjax === 'true') return;
        event.preventDefault();

        var idInput = productForm.querySelector('[name="id"]');
        var qtyInput = productForm.querySelector('[name="quantity"]');
        var payload = {
          id: idInput ? idInput.value : null,
          quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok) {
              return response.text().then(function (body) {
                console.error('Cart add ' + response.status + ' body:', body);
                throw new Error('Add to cart failed: ' + response.status);
              });
            }
            return response.json();
          })
          .then(function (addedItem) {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (typeof window.openCartBar === 'function') {
                  window.openCartBar(addedItem, cart);
                }
              });
          })
          .catch(function (err) {
            console.error('Cart AJAX failed, falling back to standard submit:', err);
            productForm.dataset.skipAjax = 'true';
            productForm.submit();
          });
      });
    }

    /* Fade-in on scroll */
    var fadeEls = document.querySelectorAll('[data-fade-in]');
    if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              fadeObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.05 }
      );
      fadeEls.forEach(function (el) { fadeObserver.observe(el); });
    } else {
      fadeEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
